import { render, staticRenderFns } from "./vue-sign.vue?vue&type=template&id=3cdbe1ed&scoped=true&"
import script from "./vue-sign.vue?vue&type=script&lang=js&"
export * from "./vue-sign.vue?vue&type=script&lang=js&"
import style0 from "./vue-sign.vue?vue&type=style&index=0&id=3cdbe1ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdbe1ed",
  null
  
)

export default component.exports